import React from 'react';
import PluBalanzaField from './PluBalanzaField';
import { TIPO_VENTA_MODO_PESO, TIPO_VENTA_MODO_UNIDAD } from '../../../utils/productoTipoVentaAdmin';

const HELP_TIPO_VENTA =
  'Usá Peso para productos vendidos por kg, como carne, fiambre, verduras o productos fraccionados.';

/**
 * Bloque Tipo de venta (Unidad / Peso) para alta/edición en Administración.
 * PLU de balanza solo visible cuando el modo es Peso.
 */
export default function TipoVentaProductoBlock({
  tipoVentaModo = TIPO_VENTA_MODO_UNIDAD,
  onTipoVentaModoChange,
  pluBalanza = '',
  onPluChange,
  onPluBlur,
  fieldClass = 'nexo-field',
  labelClassName = 'block text-sm font-medium text-e0e3-muted mb-1',
  radioLabelClass = 'inline-flex items-center gap-2 text-sm text-e0e3-muted'
}) {
  const esPeso = tipoVentaModo === TIPO_VENTA_MODO_PESO;

  const handleRadio = (modo) => {
    if (typeof onTipoVentaModoChange === 'function') {
      onTipoVentaModoChange(modo);
    }
  };

  return (
    <div className="space-y-3 rounded-xl border border-white/10 bg-white/[0.03] p-4">
      <div>
        <span className={labelClassName.replace(' mb-1', '')}>Tipo de venta</span>
        <div className="mt-2 flex flex-wrap gap-4">
          <label className={radioLabelClass}>
            <input
              type="radio"
              name="tipoVentaModo"
              value={TIPO_VENTA_MODO_UNIDAD}
              checked={tipoVentaModo === TIPO_VENTA_MODO_UNIDAD}
              onChange={() => handleRadio(TIPO_VENTA_MODO_UNIDAD)}
              className="h-4 w-4 text-e0e3-accent focus:ring-indigo-500"
            />
            Unidad
          </label>
          <label className={radioLabelClass}>
            <input
              type="radio"
              name="tipoVentaModo"
              value={TIPO_VENTA_MODO_PESO}
              checked={esPeso}
              onChange={() => handleRadio(TIPO_VENTA_MODO_PESO)}
              className="h-4 w-4 text-e0e3-accent focus:ring-indigo-500"
            />
            Peso
          </label>
        </div>
        <p className="mt-2 text-xs text-e0e3-muted">{HELP_TIPO_VENTA}</p>
        {esPeso && (
          <p className="mt-1 text-xs font-medium text-e0e3-accent">
            El precio de venta debe expresarse como precio por kg.
          </p>
        )}
      </div>

      {esPeso && (
        <PluBalanzaField
          value={pluBalanza}
          onChange={onPluChange}
          onBlur={onPluBlur}
          className={fieldClass}
          labelClassName={labelClassName}
        />
      )}
    </div>
  );
}

export { HELP_TIPO_VENTA };
